// Mapeamento centralizado de todos os data-tour attributes disponíveis por página
export const PAGE_TARGETS: Record<string, string[]> = {
  '/chat-juridico': [
    '[data-tour="conversation-sidebar"]',
    '[data-tour="new-conversation-btn"]',
    '[data-tour="messages-area"]',
    '[data-tour="suggested-questions"]',
    '[data-tour="file-upload"]',
    '[data-tour="chat-input"]',
  ],
  '/casos': [
    '[data-tour="caso-filters"]',
    '[data-tour="create-caso-btn"]',
    '[data-tour="caso-grid"]',
    '[data-tour="folder-navigation"]',
  ],
  '/casos/:id': [
    '[data-tour="caso-detail-header"]',
    '[data-tour="caso-kb-upload"]',
    '[data-tour="caso-chat"]',
    '[data-tour="caso-document-creation"]',
    '[data-tour="caso-btn-peticao"]',
    '[data-tour="caso-btn-upload-multiple"]',
    '[data-tour="caso-btn-modelos"]',
    '[data-tour="caso-search-docs"]',
    '[data-tour="caso-docs-list"]',
    '[data-tour="caso-btn-save"]',
    '[data-tour="caso-btn-pdf"]',
    '[data-tour="caso-btn-print"]',
    '[data-tour="caso-btn-copy"]',
  ],
  '/melhorar-texto': [
    '[data-tour="input-text-area"]',
    '[data-tour="customization-options"]',
    '[data-tour="formality-select"]',
    '[data-tour="document-type-select"]',
    '[data-tour="tone-select"]',
    '[data-tour="improve-button"]',
    '[data-tour="result-area"]',
    '[data-tour="action-buttons"]',
  ],
  '/calculos': [
    '[data-tour="indices-card"]',
    '[data-tour="calc-form"]',
    '[data-tour="calc-result"]',
  ],
  '/documentos': [
    '[data-tour="templates-grid"]',
    '[data-tour="create-doc-btn"]',
    '[data-tour="categories"]',
  ],
  '/dashboard': [
    '[data-tour="stats-cards"]',
    '[data-tour="recent-activity"]',
    '[data-tour="deadlines"]',
  ],
  '/compartilhamento': [
    '[data-tour="sharing-casos-compartilhados"]',
    '[data-tour="sharing-chats-compartilhados"]',
    '[data-tour="sharing-recebidos"]',
    '[data-tour="sharing-membros-ativos"]',
    '[data-tour="sharing-limite-plano"]',
    '[data-tour="sharing-ultima-atividade"]',
    '[data-tour="sharing-tab-meus-compartilhamentos"]',
    '[data-tour="sharing-tab-compartilhados-comigo"]',
    '[data-tour="sharing-tab-grupos"]',
  ],
};

/**
 * Retorna os targets disponíveis para uma página específica
 */
export const getTargetsForPage = (page: string): string[] => {
  return PAGE_TARGETS[page] || [];
};

/**
 * Retorna todas as páginas que possuem targets mapeados
 */
export const getAvailablePages = (): string[] => {
  return Object.keys(PAGE_TARGETS);
};
